<template>
<b-col>
    <otif-table :rows="rows" :columns="columns" title="Components" :actions="actions" :globalActions="[]"  class="OTPipelineAdminrule  OTTableFixTitleNoIcon"/>
    <otif-modal v-model="assignRulesModal" title="Assign Rules">
        <b-form>
            Assign rules to component {{ assignRule.componentName }}.
            <otif-select name="rules" v-model="assignRule.selectedRules" label="Assigned Rules" :values="rules" multiple/>
        </b-form>
        <template slot="footer">
            <otif-button class="OTSecondary" @click.native="assignRulesModal = false">Cancel</otif-button>
            <otif-button class="OTPrimary" @click.native="saveAssignedRules">Save</otif-button>
        </template>
    </otif-modal>
</b-col>
</template>

<script>

import axios from 'axios';

import AppliedRulesColumn from './table/AppliedRulesColumn.vue';

export default {

    data() {
        return {
            assignRulesModal: false,
            assignRule: {
                rowNumber: null,
                componentName: '',
                componentId: '',
                selectedRules: []
            },
            rows: [],
            componentRules: [],
            components: [],
            actions: [{
                name: 'assign',
                label: 'Assign Rules',
                callback: this.assignRules
            }],
            columns: [{
                name: 'name',
                label: 'Component'
            },{
                name: 'rules',
                label: 'Applied Rules',
                displayComponent: AppliedRulesColumn
            }],

            rules: [],
            rule_mapping: {}
        };
    },

    methods: {

        assignRules(rowNumber) {
            this.assignRulesModal = true;

            const component = this.componentRules[rowNumber];

            this.assignRule.rowNumber = rowNumber;
            this.assignRule.componentName = component.name;
            this.assignRule.componentId = component.path.replace('otif/v3/admin', 'mtm-gateway-api/v1/services/pipeline');
            this.assignRule.selectedRules = component.activationRules.map((rule) => rule.ruleId);
        },

        async load() {
            const compres = await axios.get('/mtm-gateway-api/v1/services/pipeline/pipeline-components');
            const rules   = await axios.get('/mtm-gateway-api/v1/services/pipeline/activation-rules');
            this.rule_mapping = {};

            this.rules = rules.data.activationRules.map((rule) => {
                this.rule_mapping[rule.ruleId] = rule.ruleName;
                return {value: rule.ruleId, label: rule.ruleName};
            });


            this.componentRules = compres.data.components;

            compres.data.components.forEach((component) => {
                this.rows.push([component.name, component.activationRules.map((r) => this.rule_mapping[r.ruleId])])
            });
        },

        async saveAssignedRules() {

            this.$snotify.info('Assigning rules', {timeout: 0});

            try {

                const componentPath = '/' + this.assignRule.componentId;

                const componentRes = await axios.get(componentPath);
                const component = componentRes.data;

                component.activationRules = {
                    value: this.assignRule.selectedRules.map((rule) => {
                        return { ruleId: rule }
                    })
                }

                await axios.put(componentPath, component);

                this.rows.splice(this.assignRule.rowNumber, 1, [this.assignRule.componentName, component.activationRules.value.map((r) => this.rule_mapping[r.ruleId])]);
                const compres = await axios.get('/mtm-gateway-api/v1/services/pipeline/pipeline-components');
                this.componentRules = compres.data.components;


                this.$snotify.clear();
                this.$snotify.success('Rules assigned');
            } catch (e) {
                console.error(e);
                this.$snotify.clear();
                this.$snotify.error('There was an error assigning rules');
            }

            this.assignRulesModal = false;
        }
    },

    created() {
        this.load();
    }
};


</script>
